import { InitOptions } from 'i18next';
import { AppI18NLanguageInfo } from './types';

export const fallbackLng = 'en';
export const defaultNS = 'translation';

export const cookieName = 'i18n_language';
export const headerName = 'x-i18n-language';

export const languages: Record<string, AppI18NLanguageInfo> = {
  en: {
    code: 'en',
    name: 'English',
    nativeName: 'English',
  },
  pl: {
    code: 'pl',
    name: 'Polish',
    nativeName: 'Polski',
  },
};

export const supportedLngs = Object.keys(languages);

export function getOptions(
  lng: string = fallbackLng,
  ns: string = defaultNS,
  isDev: boolean = false,
  extraSettings: any = {}
): InitOptions {
  return {
    debug: true, //isDev,
    supportedLngs,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns: ['privacy', 'translation', 'validation'],
    ...extraSettings,
  };
}
